import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../api/client";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const { t } = useTranslation();

  useEffect(() => {
    const token = params.get("token");

    if (!token) {
      setStatus("error");
      return;
    }

    fetch(`${API_BASE_URL}/api/v1/auth/verify?token=${token}`)
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then(() => {
        setStatus("success");
        setTimeout(() => navigate("/login"), 2000);
      })
      .catch(() => {
        setStatus("error");
      });
  }, [params, navigate]);

  if (status === "loading") return <p>{t("auth.verifyEmail.loading")}</p>;
  if (status === "success") return (  
  <div className="content">
    <Header />
    <div className="center-content">
      <p>{t("auth.verifyEmail.success")}</p>
    </div>
    <Footer />
    </div>
    );
  return (
    <div className="content">
    <Header />
    <p className="errorMessage">{t("auth.verifyEmail.error")}</p>;
    <Footer />
    </div>
  )
  
}